import * as $ from "jquery";
//import "handsontable";
//import Handsontable from 'handsontable/dist/handsontable.full.js';
//import { ViewRenderer } from 

//mport "numbro/dist/numbro.js";
//import "numbro/dist/languages.min.js";
import Handsontable from 'handsontable/dist/handsontable.full'
//import Handsontable from "handsontable";
import 'handsontable/dist/handsontable.full.css';

//declare var Handsontable: any;

import { IViewData, ViewRenderer } from "./ah.mb.ui.view-builders";


    /**
     * Nvd3 chart renderer
     */
    export class HandsontableRenderer implements ViewRenderer {

        private instance: Handsontable;

        forceViewType(chartSeriesTypeId: number): void {
            // Not implemented
        }

        private readonly initOptions: Handsontable.Options;

        /**
         * Ctor
         */
        constructor(options: Handsontable.Options) {
            this.initOptions = options;

            // Globally increase the copy limit - default is 1000
            this.initOptions.copyRowsLimit = 10000;

            //this.drawTable(this.theTableContainer, theData, settings);

        }

        /**
         * Clears the chart
         * @param target
         */
        clear(): void {
            const instance = this.getTable();
            if (instance)
            instance.updateSettings({
                data: []
            });
//                instance.clear();
//            while (target.children().length > 0)
            //              target.children().remove("*");
        }

        /**
         * Before render
         * @param target
         * @param viewName
         */
        private beforeRender(target: JQuery, viewName: string): Promise<any> {

            //this.clear(target);

            // var svgId = viewName + "_svg";

            //var toolsBtn = '<button type="button" class="btn btn-primary btn-xs" data-toggle="button">Single toggle</button>';
           // var toolsBtn = '<button type="button" class="btn btn-link">Table</button>';
            //target.append(toolsBtn);

            const selectedCheckBox = `<div class="checkbox view-selector-checkbox-div" class="viewSelecterCheckBoxDiv">
                    <label><input type="checkbox" class="viewSelectorCheckBox" value="selected" data-viewid="${viewName}"> </input>
                        <span>${viewName}</span>
                        </label>`;

            //'<div class="checkbox" style="margin-top:0">'
            //    + '<label style="font-weight:bold; margin-left:10px">'
            //    + '<input type="checkbox" class="viewSelectorCheckBox" value="selected" data-viewid="' + viewName + '">'
            //    + viewName
            //    + "</label>"
            //    + "</div>";
              
            target.append(selectedCheckBox);

            //const svg = '<svg style="position: absolute"></svg>';

            var targetDiv = `<div class="nodeViewTableDiv"></div>`;

            target.append(targetDiv);

            // Show loader indication
            return this.showLoadingIndicator(target.find(".nodeViewTableDiv"));


        }

        /**
         * Shows the loading indicator
         * @param target
         */
        private showLoadingIndicator(target: JQuery): Promise<any> {

            const loaderDiv = '<div id="loader" class="center-x-and-y">' +
                '<img alt="activity indicator"  src= "/Content/ajax-loader.gif" class="center-x-and-y">' +
                "</div>";

            target.append(loaderDiv);

            //$("#loader").show();

            return Promise.resolve(); // $.Deferred().resolve();

        }

                                                                  
        /**
         * Hides loading indicator
         * @param target
         */
        private hideLoadingIndicator(target: JQuery): Promise<any> {
            target.find("#loader").hide();

            return Promise.resolve();
            // return $.Deferred().resolve();

        }

        /**
         * After render
         * @param target
         * @param viewName
         */
        private afterRender(target: JQuery, viewName: string): Promise<any> {
            return this.hideLoadingIndicator(target);
        }

        /**
         * Renders the view
         * @param target
         * @param data
         */
        render = (target: JQuery, data: IViewData): void => {

            var columnNames = [data.xAxisDataType, data.yAxisDataType];
            
            var hotData = [
            {
                ColumnNames: columnNames,
                Value: []
                }];

            // Todo: Fix this

            // If there are multiple values, there are multiple nodes so we need multiple rows
            // This would happen e.g. for a sector report on nodes in that sector
            // Rather than a report for a single node
            //var needNodeNames = data.result.length > 1;

            //// If need nodenames, add a column for it
            //if (needNodeNames)
            //    hotData[0].ColumnNames.splice(0, 0, "Node");
 
            //// Need to translate viewdata into handsontable data
            //data.result.forEach(curResult => {

            //    var value = curResult.values[0];
            //    if (data.dataType.toLowerCase() === "boolean") {

            //        const newVal = value[0][1] === 1 ? "true" : "false";
            //        value[0][1] = newVal;
            //    }

            //    // If we need to differentiate the node, insert it at index 0
            //    // Not the whole path, its too long
            //    if (needNodeNames) {
            //        const nodeName = ModelUtils.extractName(curResult.key);
            //        value.splice(0, 0, nodeName);
            //    }
            //    hotData[0].Value.push(value);

            //});

            // Before render
            this.beforeRender(target, data.title).then(
                () => {
                    // Have to select the target div
                    target = target.find(".nodeViewTableDiv");
                    this.drawTable(target, hotData,"")
                        .then(() => this.afterRender(target, data.title));

               });
        }

        /**
         * Refreshes the view
         */
        refresh() {
            // not needed yet
        }

        /**
         * Draws the graph
         * @param target
         * @param reportResults
         */
        drawTable(target: JQuery, data:any, variableName: string, cellsFunc?: (row: number, col: number, prop: string) => void): Promise<any> {


            let hot = this.instance;
//                let hot:Handsontable.Context =  target.handsontable("getInstance");

            if (!hot) {

                this.instance = new Handsontable(target.get(0), this.initOptions);

//                 this.instance =  (target as any).handsontable(this.initOptions);
                 hot = this.instance;
//                 hot = target.handsontable("getInstance");
            }
            if (data.length > 0) {
                const theData = data[0].value;

                // For tags, we allow removing and adding rows.
                // Todo: Make the server determine this
                var isFreeFormData = variableName == "Tags";
                var maxRows = isFreeFormData? theData.length + 10 : theData.length;
                var minSpareRows = isFreeFormData ? 1 : 0;
                if (isFreeFormData)
                    data[0].columnDefs[0].readOnly = false;

                //var colHeaders = []
                //hot.colHeaders = true;

                var prevKey;
                const updatedSettings: Handsontable.Options = {
                    colHeaders: data[0].columnNames, // Column headers etc
                    data: theData, // The array of data
                    columns: data[0].columnDefs, // Same as colheaders
                    cells: cellsFunc, // Cell properties
                    minSpareRows: minSpareRows, // If > 0, can add additional rows
                    maxRows: maxRows,
                    rowHeaders: isFreeFormData,
                    beforeKeyDown: function (e) {
                        if (isFreeFormData && prevKey === 'Control')
                            switch (e.key) {
                                case "Delete":
                                    {
                                        var selected = hot.getSelectedRange();
                                        hot.alter('remove_row', selected.from.row, selected.to.row - selected.from.row + 1); /// //, selected.to.row - selected.from.row);
                                        Handsontable.Dom.stopImmediatePropagation(event);
                                        break;
                                    }
                                    case "Insert":
                                    {
                                        var selected = hot.getSelectedRange();
                                        hot.alter('insert_row', selected.from.row); /// //, selected.to.row - selected.from.row);
                                        Handsontable.Dom.stopImmediatePropagation(event);
                                        break;
                                    }

                                default: ;
                        }
                        prevKey = e.key;
                    }
                };

                hot.updateSettings(updatedSettings);

                hot.render();

                return Promise.resolve();

            }

            return Promise.resolve();
            }

        /**
         * Gets the table instance
         */
        getTable = (): Handsontable.Core => {
//            var hot = Handsontable.helper.(target);

//            var hot: Handsontable.Context = new Handsontable.Core.getInstance(target);
                //handsontable("getInstance");
                return this.instance; //is.th;

        }
    }
    


// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.ui.HandsontableRenderer.ts